import { useAuth } from '../context/AuthContext';
import RoleNavBar from '../components/Navigation/RoleNavBar';
import { Outlet, useMatches, Route } from 'react-router-dom';
import { LoadState } from '@diditusa/shared/types/commonTypes';
import LoadingIndicator from '@diditusa/shared/web_components/LoadingIndicator/loadingIndicator';
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';

const Layout: React.FC = () => {
  const { isAuthenticated, loadState, user } = useAuth();
  const [showNavbar, setShowNavbar] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowNavbar(true);
      } else {
        setShowNavbar(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [showNavbar]);

  if (loadState === LoadState.LOADING) {
    return <LoadingIndicator isVisible={loadState === LoadState.LOADING} />;
  }

  return (
    <Box sx={{ bgcolor: isAuthenticated ? '#fff' : '#1a1a1a' }}>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          width: '100%',
          zIndex: 100,
          transition: 'transform 0.3s ease, opacity 0.3s ease',
          transform: showNavbar || isAuthenticated ? 'translateY(0)' : 'translateY(-100%)',
          opacity: showNavbar || isAuthenticated ? 1 : 0,
        }}
      >
        <RoleNavBar />
      </Box>
      <main
        style={{
          backgroundColor: '#fff',
          paddingTop: isAuthenticated ? '64px' : 0,
          transition: 'paddingTop 0.3s ease',
        }}
      >
        <Outlet />
      </main>
    </Box>
  );
};

export default Layout;
